import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';

import {
  ACADEMY_PROJECT_MODAL_STAGES,
  academyProjectSelector,
  setAcademyProject,
  setAcademyProjectModalStage,
} from 'features/classCreation';
import Field from 'components/Field';
import Input from 'components/Input';
import SectionHeading from 'components/SectionHeading';
import styles from './AcademyProjectModalCreateStage.module.scss';

export default function AcademyProjectModalCreateStage() {
  const dispatch = useDispatch();
  const academyProject = useSelector(academyProjectSelector);
  const [academyProjectId, setAcademyProjectId] = useState('');

  const handleOnClick = useCallback(() => {
    dispatch(setAcademyProjectModalStage(ACADEMY_PROJECT_MODAL_STAGES.details));
  }, [dispatch]);

  const handleInputChange = useCallback(
    (e) => {
      setAcademyProjectId(e.target.value);
      dispatch(setAcademyProject({ ...academyProject, id: e.target.value }));
    },
    [dispatch, academyProject]
  );

  return (
    <>
      <SectionHeading
        title="ADD CASE STUDY"
        className={styles.sectionHeading}
      />
      <Field
        name="title"
        label="Case Study slug ID"
      >
        <Input
          className={styles.inputField}
          placeholder="Case Study ID"
          value={academyProjectId}
          onChange={handleInputChange}
        />
      </Field>
      <Tappable
        className="btn btn-primary btn-long"
        onClick={handleOnClick}
      >
        Confirm
      </Tappable>
    </>
  );
}
